import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import '../styles/Register.css';

export default function PasswordRecovery({ reset = false }) {
  const { token } = useParams();
  const [rollNumber, setRollNumber] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  async function submit(event) {
    event.preventDefault();
    setError('');
    if (reset && password !== confirmation) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      const csrf = document.cookie.match(/csrftoken=([^;]+)/);
      const response = await fetch(`/api/authentication/${reset ? 'reset-password' : 'forgot-password'}/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(csrf ? { 'X-CSRFToken': csrf[1] } : {}) },
        body: JSON.stringify(reset ? { token, password } : { ldap: `${rollNumber.trim().toLowerCase()}@iitb.ac.in` }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || data.detail || 'Unable to process your request. Please try again.');
      setMessage(data.message);
      setPassword('');
      setConfirmation('');
    } catch (err) {
      setError(err.message || 'Unable to connect. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <form className="form-container" onSubmit={submit}>
      <h1 className="heading">{reset ? 'Reset password' : 'Forgot password?'}</h1>
      {!message && <>
        {reset ? <>
          <p style={{ color: 'white' }}>Use 8–100 characters. Avoid common or entirely numeric passwords.</p>
          <input className="input" aria-label="New password" type="password" autoComplete="new-password" placeholder="New password" minLength={8} maxLength={100} required value={password} onChange={e => setPassword(e.target.value)} />
          <input className="input" aria-label="Confirm new password" type="password" autoComplete="new-password" placeholder="Confirm new password" minLength={8} maxLength={100} required value={confirmation} onChange={e => setConfirmation(e.target.value)} />
        </> : <>
          <p style={{ color: 'white' }}>Enter your registered roll number to receive a reset link in your IIT Bombay webmail.</p>
          <div className="email-input">
            <input className="input" aria-label="Roll number" placeholder="Roll Number" autoComplete="username" required pattern="[^@\s]+" value={rollNumber} onChange={e => setRollNumber(e.target.value)} />
            <span className="email-domain">@iitb.ac.in</span>
          </div>
        </>}
        <div role="alert" style={{ color: 'white' }}>{error}</div>
        <button className="button" type="submit" disabled={loading}>{loading ? 'Please wait…' : reset ? 'Change password' : 'Send reset link'}</button>
      </>}
      {message && <p role="status" style={{ color: 'white' }}>{message}</p>}
      <Link to="/login" style={{ color: 'white' }}>Back to login</Link>
    </form>
  );
}
